<template>
    <div>
        <ul class="lenta-post">
            <li v-for="item in data"
                :key="item.id"
                :data-id="item.id"
            >
                <div class="post">
                    <div class="post-image"
                         v-if="item.image"
                    >
                        <a :href="item.link"
                           :target="item.target"
                           @click="click($event, item)"
                        >
                            <img :src="item.image" alt="">
                        </a>
                    </div>
                    <div class="post-title">
                        <a :href="item.link"
                           :target="item.target"
                           @click="click($event, item)"
                        >{{ item.title }}</a>
                    </div>
                    <!--<div class="post-anons">-->
                        <!--Глава государства уже традиционно покупает мороженое на&nbsp;одном из&nbsp;крупнейших мировых авиафорумов.-->
                        <!--Этот раз не&nbsp;стал исключением. Вместе с&nbsp;членами правительства и&nbsp;руководителями крупных промышленных-->
                        <!--предприятий...-->
                    <!--</div>-->
                    <div class="post-time">{{ item.date }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from "axios";

    const LIST_LINK = "/api/news";

    export default {
        name: 'News',
        data() {
            return {
                data: {}
            };
        },
        mounted() {
            axios.get(LIST_LINK)
                .then((response) => {
                    this.data = response.data ? response.data : [];
                });
        },
        methods: {
            click(e, item) {

                console.log(item);

                if (item.target !== "_self") {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                if (item.link === true) {
                    this.$router.push({name: 'news', params: {id: item.id}});
                }
            }
        }
    }
</script>